<template>
  <va-card>
    <template slot="header">
      <div class="va-card__header-title" color="secondary">
        <span v-if="$route.params.id">
          <router-link to="/">{{ $t('menu.dashboard') }}</router-link> / <router-link to="/ekstra/listesi">{{ $t('menu.vehicleExtras') }}</router-link> / {{ item.name_readable }}
        </span>
        <span v-else>
          <router-link to="/">{{ $t('menu.dashboard') }}</router-link> / <router-link to="/ekstra/listesi">{{ $t('menu.vehicleExtras') }}</router-link> / {{ $t('tables.actions.create') }}
        </span>
      </div>
      <div class="va-card__header-actions"/>
    </template>
    <form @submit.prevent="onsubmit">
      <input type="hidden" v-model="form.language"/>
      <div class="row">
        <div class="flex md4 sm6 xs12">
          <va-input
            v-model="form.name"
            label="İsim"
            placeholder="Ekstra ismi girin"
            required
          />
        </div>
        <div class="flex md4 sm6 xs12">
          <va-input
            type="number"
            step="any"
            v-model="form.price"
            label="Ekstra / Gün"
            placeholder="Günlük ekstra fiyatı girin"
            required
          >
            <va-icon
              slot="append"
              color="gray"
              name="fa fa-turkish-lira"
            />
          </va-input>
        </div>
        <div class="flex md8 sm12 xs12">
          <va-input
            type="textarea"
            :min-rows="4"
            v-model="form.description"
            label="Açıklama"
            placeholder="Ekstra açıklaması girin"
          />
        </div>
      </div>
      <div class="row">
        <va-button type="submit">Kaydet</va-button>
      </div>
    </form>
  </va-card>
</template>

<script>
import vehicleExtraServices from '../../../services/api/vehicleExtra'
import responseMixin from '../../../services/api/response'
export default {
  mixins: [responseMixin],
  data () {
    return {
      item: {},
      form: {
        language: 'tr',
        name: '',
        description: '',
        price: null
      }
    }
  },
  methods: {
    async getVehicleExtra(id){
      const result = await vehicleExtraServices.get(id);
      if(result.error){
        return ;
      }
      this.item = result.data.data;
      this.form = JSON.parse(JSON.stringify(this.item));
      this.form.language = 'tr';
      this.form.name = this.form.name.tr;
      this.form.description = !!this.form.description && this.form.description.tr ? this.form.description.tr : '';
    },
    async putVehicleExtra(id) {
      const res = await vehicleExtraServices.put(id, {
        data: this.form
      });
      if(res.error){
        //error handling
        this.responseToast('PUT', 'error', res);
        return ;
      }
      this.responseToast('PUT', 'success');
    },
    onsubmit () {
      //validation
      if(this.$route.params.id) {
        this.putVehicleExtra(this.$route.params.id);
      }
    },
  },
  created () {
    if(this.$route.params.id) {
      this.getVehicleExtra(this.$route.params.id);
    }
  },
}
</script>